'use client';
import * as React from 'react';

export interface AnchorProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  target?: string;
}

const Anchor = React.forwardRef<HTMLDivElement, AnchorProps>(
  ({ target, ...props }, ref) => {
    const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (target) {
        // Ensure target is a valid CSS selector (add # if it's just an id)
        const selector = target.startsWith('#') ? target : `#${target}`;
        const el = document.querySelector(selector);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          console.warn(`Anchor target not found: ${selector}`);
        }
      }
    };
    return (
      <div
        ref={ref}
        {...props}
        onClick={onClick}
        style={{ ...props.style, cursor: 'pointer' }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick(e as any);
          }
        }}
      />
    );
  },
);
Anchor.displayName = 'Anchor';

export { Anchor };
export default Anchor;
